// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container__2PYDJ","activeGoodsBg":"main_activeGoodsBg__3XhLg"};